'use strict';

angular.module('casist.ucto')
  .factory('SupisDPH', ['Restangular', '$q', 'BaseModel', 'BaseCollectionModel', 'Profile', function (Restangular, $q, BaseModel, BaseCollectionModel, Profile) {
    var ENDPOINT = 'supisdph';
    Restangular.extendModel(ENDPOINT, function(model) {
      angular.extend(model, BaseModel)
      return angular.extend(model, {
        validate: function() {
          return BaseModel.validate();
        }
      });
    });
    return angular.extend(BaseCollectionModel.object(ENDPOINT), {
      getPerms: function() {
        return Profile.get('perms').supisdph;
      }
    });
  }]);